module.exports = __webpack_public_path__ + "img/smsa.fba59f9f.png";